export default __webpack_public_path__ + "static/media/arenProCover.f869dd64.jpg";